import {entities} from '../../../../../../util/uiconstants';
import _ from 'lodash';

const mapResponse = {
	Controls: (response) => {
		if (response) {
			return response.map((control) => {
				return {
					name: control.controlName,
					entityId: entities.Control,
					id: control.id
				};
			});
		}
	},
	Scot: (response) => {
		if (response) {
			return response.map((scot) => {
				return {
					name: scot.scotDisplayName,
					entityId: entities.SCOT,
					id: scot.id,
					hasRisk: scot.hasRiskAssociated
				};
			});
		}
	},

	ItsoApplication: (response) => {
		if (response && response.data && response.data.length > 0) {
			return response.data.map((itsoApp) => {
				return {
					name: itsoApp.itApplicationName,
					entityId: entities.ItSoApplication,
					id: itsoApp.id
				};
			});
		} else if (Array.isArray(response) && response.length > 0) {
			return response.map((itsoApp) => {
				return {
					name: itsoApp.itApplicationName,
					entityId: entities.ItSoApplication,
					id: itsoApp.id
				};
			});
		}
	},

	ItProcess: (response) => {
		if (response) {
			return response.map((itProcess) => {
				return {
					name: itProcess.itProcessName,
					entityId: entities.ItProcess,
					id: itProcess.id
				};
			});
		}
	},

	itProcessesItControls: (response) => {
		if (response) {
			return _.compact(
				response.map((itProcess) => {
					if (itProcess.itControls && Array.isArray(itProcess.itControls) && itProcess.itControls.length > 0) {
						return {
							name: itProcess.itProcessName,
							entityId: entities.ItProcess,
							id: itProcess.id,
							children: itProcess.itControls.map((itControl) => {
								return {
									name: itControl.itControlName,
									entityId: entities.ItControl,
									id: itControl.id,
									parentId: itControl.itProcessId
								};
							})
						};
					}
				})
			);
		}
	},

	ITControl: (response) => {
		let items = null;

		if (response && response.data) {
			items = response.data;
		} else if (Array.isArray(response)) {
			items = response;
		}
		if (items) {
			return items.map((itControl) => {
				return {
					name: itControl.itControlName,
					entityId: entities.ItControl,
					id: itControl.id
				};
			});
		}
	},

	ScotsControls: (response) => {
		if (response) {
			return _.compact(
				response.map((scot) => {
					if (scot.controls && Array.isArray(scot.controls) && scot.controls.length > 0) {
						return {
							name: scot.scotDisplayName,
							entityId: entities.SCOT,
							id: scot.id,
							children: scot.controls.map((control) => {
								return {
									name: control.controlName,
									entityId: entities.Control,
									id: control.id,
									parentId: control.scotId
								};
							})
						};
					}
				})
			);
		}
	},

	ScotsWcgws: (response, wcgwsRequired) => {
		let scotWcgwData;
		let wcgwCount = 0;

		if (response && response.data) {
			scotWcgwData = response.data
				.filter((scot) => scot.wcgWs && scot.wcgWs.length > 0)
				.map((scot) => {
					return {
						entityName: scot.scotDisplayName,
						entityId: entities.SCOT,
						entityUId: scot.id,
						id: scot.id,
						children:
							scot.wcgWs &&
							scot.wcgWs.length > 0 &&
							scot.wcgWs.map((wcgw) => {
								wcgwCount++;
								return {
									entityName: wcgw.wcgwName,
									entityId: entities.WCGW,
									entityUId: wcgw.id,
									id: wcgw.id,
									hasRelatedRisks: wcgw.hasRelatedRisk
								};
							})
					};
				});

			if (wcgwsRequired && wcgwCount === 0) {
				scotWcgwData = [];
			}

			return scotWcgwData;
		}
	},

	Accounts: (response) => {
		if (response) {
			return response.map((account) => {
				return {
					name: account.accountName,
					entityId: entities.Account,
					id: account.id
				};
			});
		}
	},

	STEntities: (response) => {
		if (response) {
			return response.map((stEntity) => {
				return {
					name: stEntity.stEntityName,
					entityId: entities.STEntity,
					id: stEntity.id
				};
			});
		}
	},

	Estimates: (response) => {
		if (response) {
			return response.map((risk) => {
				return {
					name: risk.riskName,
					entityId: entities.Estimate,
					id: risk.id
				};
			});
		}
	},

	GAComponents: (response) => {
		if (response) {
			return response.map((component) => {
				return {
					name: component.shortName,
					entityId: entities.GaComponent,
					id: component.gaComponentId
				};
			});
		}
	},

	Deficiencies: (response) => {
		if (response) {
			return response.map((deficiency) => {
				return {
					name: deficiency.description,
					entityId: entities.Deficiency,
					id: deficiency.id
				};
			});
		}
	},
	ItApplication: (response) => {
		if (response && response.data && response.data.length > 0) {
			return response.data.map((itApp) => {
				return {
					name: itApp.itApplicationName,
					entityId: entities.ITApplications,
					id: itApp.id
				};
			});
		} else if (Array.isArray(response) && response.length > 0) {
			return response.map((itApp) => {
				return {
					name: itApp.itApplicationName,
					entityId: entities.ITApplications,
					id: itApp.id
				};
			});
		}
	}
};

export default mapResponse;
